export const DEFAULT_ROUTE_CATEGORY_CONFIG = {
  // '/coffees': {
  //   rootCategoryId: '22',
  //   rootSlug: 'coffees',
  //   title: 'Καφές',
  //   description: 'Διαχειριστείτε τα προϊόντα καφέ και τις υποκατηγορίες τους.',
  // },
  // '/drinks': {
  //   rootCategoryId: '24',
  //   rootSlug: 'drinks',
  //   title: 'Ροφήματα',
  //   description: 'Διαχειριστείτε τα ροφήματα και τις υποκατηγορίες τους.',
  // },
  // '/blends': {
  //   rootCategoryId: '22',
  //   rootSlug: 'coffees',
  //   title: 'Καφές',
  //   description: 'Διαχειριστείτε τα προϊόντα καφέ και τις υποκατηγορίες τους.',
  // },
};

export const getTopLevelCategories = (rawResponse) => {
  const categories = Array.isArray(rawResponse)
    ? rawResponse
    : Array.isArray(rawResponse?.data)
      ? rawResponse.data
      : Array.isArray(rawResponse?.categories)
        ? rawResponse.categories
        : [];

  return categories.filter(
    (category) =>
      category && (category.parent_id === null || category.parent_id === undefined)
  );
};

export const buildRouteCategoryConfig = (categories = [], fallback = DEFAULT_ROUTE_CATEGORY_CONFIG) => {
  const normalizedConfig = { ...(fallback || {}) };

  categories.forEach((category) => {
    if (!category) return;
    const slug = (category.slug || '').toLowerCase();
    if (!slug) return;
    const route = `/${slug}`;
    const title = category.name || slug.charAt(0).toUpperCase() + slug.slice(1);
    normalizedConfig[route] = {
      rootCategoryId: category.id ? String(category.id) : '',
      rootSlug: slug,
      title,
      description:
        category.description ||
        `Διαχειριστείτε την κατηγορία ${title}.`,
    };
  });

  return normalizedConfig;
};
